import React from 'react';

import Button from '@atlaskit/button/new';

const ButtonSelectedExample = (): React.JSX.Element => {
	return <Button isSelected>Selected button</Button>;
};

export default ButtonSelectedExample;
